import { assert } from '@sindresorhus/is';
import { createContext, useContext } from 'react';

import type { OrderedUrlTile } from './comments-group';
import type { ParsedUrlTile, UrlTileMutationOptions, UrlTilePayload } from './types';

export type UrlTileContextValue = {
    readonly closeTile: (slotKey: string, options?: UrlTileMutationOptions) => void;
    readonly openTile: (payload: UrlTilePayload, options?: UrlTileMutationOptions) => void;
    readonly orderedTiles: readonly OrderedUrlTile[];
    readonly tiles: readonly ParsedUrlTile[];
    readonly updateTile: (payload: UrlTilePayload, options?: UrlTileMutationOptions) => void;
};

export const UrlTileContext = createContext<UrlTileContextValue | null>(null);

export const useUrlTiles = (): UrlTileContextValue => {
    const context = useContext(UrlTileContext);
    assert.plainObject(context);

    return context;
};

export const useOptionalUrlTiles = (): UrlTileContextValue | null => useContext(UrlTileContext);
